import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.easing';

// import './templates/quiz.js';

import { dm_reveal } from './config/scroll_reveal.js';
// import { dm_geo_locate } from './components/geo-locate.js';
// import { dm_nav } from './components/nav.js';
// import { dm_search } from './components/search.js';
// import { dm_nav_vacancy } from './components/nav-vacancy.js';
// import { dm_vimeo_modal } from './components/vimeo.js';
// import { dm_back_to_top } from './components/back-to-top.js';
// import { dm_hero_animation } from "./components/hero-animation.js";


import { dm_h_01_header } from './modules/h-01-header.js';
import { dm_a02 } from './modules/a-02';

// import { dm_h_02_header_with_media } from './modules/h_02_header_with_media.js';
// import { dm_a_02_latest_job_cards } from './modules/a_02_latest_job_cards.js';
// import { dm_a_03_more_people_stories } from './modules/a_03_more_people_stories.js';
// import { dm_c_04_feature_1 } from './modules/c_04_feature_1_drop.js';
// import { dm_c_04_feature_2 } from './modules/c_04_feature_1_rotate.js';
// import { dm_c_05_feature_2 } from './modules/c_05_feature_2.js';
// import { dm_c_06_tabbed_slider } from './modules/c_06_tabbed_slider.js';
// import { dm_c_07_history_slider } from './modules/c_07_history_slider.js';
// import { dm_c_10_featured_stories } from './modules/c_10_featured_stories.js';
// import { dm_c_11_stories } from './modules/c_11_stories.js';
// import { dm_c_12_more_stories } from './modules/c_12_more_stories.js';
// import { dm_c_13_video_cards } from './modules/c_13_video_cards.js';
// import { dm_c_14_perk_cards } from './modules/c_14_perk_cards.js';
// import { dm_applyCircleAnimationOnButtonHover } from "./utils/buttons.js";
// import { dm_soh_01_header } from "./modules/soh-01-header.js";
// import { dm_soc_02_stats } from "./modules/soc-02-stat.js";
// import { dm_soc_01_cards } from "./modules/soc-01-cards.js";
// import { dm_c_05_image_cards } from "./modules/soc-05-image-cards.js";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([Navigation]);
// import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

jQuery(function ($) {
    "use strict";
    console.log('LOADED');

    dm_reveal();
    // dm_nav();
    // dm_nav_vacancy();
    // dm_vimeo_modal();
    // dm_back_to_top();
    // const shouldRunHeroAnimation =
    //     document.body.classList.contains('has-hero-animation') ||
    //     document.querySelector('[data-hero-animation="1"]');
    // if (shouldRunHeroAnimation) {
    //     dm_hero_animation();
    // }
    // Initialize header parallax only when header exists
    if (document.querySelector('.h-01-header')) {
        dm_h_01_header();
    }
    if ( document.querySelector('.a-02-social-feed')){
        dm_a02();
    }
    // dm_h_02_header_with_media();
    // dm_a_02_latest_job_cards();
    // dm_a_03_more_people_stories();
    // dm_c_05_feature_2();
    // dm_c_06_tabbed_slider();
    // dm_c_07_history_slider();
    // dm_c_10_featured_stories();
    // dm_c_12_more_stories();
    // dm_c_11_stories();
    // dm_c_13_video_cards();
    // dm_c_14_perk_cards();
    // dm_search();

    // dm_geo_locate();
    // dm_applyCircleAnimationOnButtonHover();
    
    // dm_soh_01_header();
    // dm_soc_01_cards();
    // dm_soc_02_stats();
    // dm_c_05_image_cards();
});